"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styled = require("@datepicker-react/styled");
var _automationHooks = require("@airportlabs/automation-hooks");
var DateParts = _interopRequireWildcard(require("./DateParts"));
var _DateInputPrevNext = _interopRequireDefault(require("./DateInputPrevNext"));
var _DatePickerReactStyled = _interopRequireDefault(require("./DatePickerReactStyled"));
var _useTimezoneDate2 = _interopRequireDefault(require("../_hooks/useTimezoneDate"));
var _DateInput = require("./DateInput");
var _helpers = require("./helpers");
var _excluded = ["onChange", "value", "format", "minBookingDate", "maxBookingDate", "isDateBlocked", "hasError", "isEndOfDay", "w", "width", "align", "isRequired", "automationHook", "disabled"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var propTypes = exports.propTypes = _objectSpread(_objectSpread({
  /** Used to set the saved date value when a date is selected. */
  onChange: _propTypes["default"].func.isRequired,
  /** Initial value for the DatePicker. Should be a JS Date object. Will default to now. */
  value: _propTypes["default"].object,
  /** A Luxon DateTime Format String, used to represent the date. By default the date will be displayed in this format: MMMM DD, YYYY*/
  format: _propTypes["default"].string
}, _DateInput.commonDateInputPropTypes), {}, {
  /** React Tiny Popover API https://github.com/alexkatz/react-tiny-popover#popover
   * Alignment of the Popover relative to the input
   * Default is "start"
   */
  align: _propTypes["default"].oneOf(["start", "center", "end"]),
  /** DatePicker API: https://github.com/tomgreenwood1/react-datepicker#datepicker
   * Date object representing minimum selectable date in the past. Will be used to also disable previous button.
   */
  minBookingDate: _propTypes["default"].object,
  /** DatePicker API: https://github.com/tomgreenwood1/react-datepicker#datepicker
   * Date object representing maximum selectable date in the future. Will be used to also disable next button.
   */
  maxBookingDate: _propTypes["default"].object,
  /** DatePicker API: https://github.com/tomgreenwood1/react-datepicker#datepicker
   * Function that takes a date and evaluates if it is blocked or not. Will be used to also disable previous/next buttons.
   */
  isDateBlocked: _propTypes["default"].func,
  /** The width of the trigger field */
  w: _propTypes["default"].string,
  /** DEPRECATED The width of the trigger field */
  width: _propTypes["default"].string,
  /** mark input as required */
  isRequired: _propTypes["default"].bool,
  /** Wether this field should be displayed as having an error. */
  hasError: _propTypes["default"].bool,
  /** When true return end of selected date. Otherwise defaults to start of selected date */
  isEndOfDay: _propTypes["default"].bool,
  /** Hook used for automation testing.*/
  automationHook: _propTypes["default"].string
});
var DatePickerPrevNext = function DatePickerPrevNext(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? "dd/MM/yyyy" : _ref$format,
    minBookingDate = _ref.minBookingDate,
    maxBookingDate = _ref.maxBookingDate,
    isDateBlocked = _ref.isDateBlocked,
    hasError = _ref.hasError,
    _ref$isEndOfDay = _ref.isEndOfDay,
    isEndOfDay = _ref$isEndOfDay === void 0 ? false : _ref$isEndOfDay,
    w = _ref.w,
    width = _ref.width,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? "start" : _ref$align,
    isRequired = _ref.isRequired,
    automationHook = _ref.automationHook,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTimezoneDate = (0, _useTimezoneDate2["default"])(),
    getFromJSDate = _useTimezoneDate.getFromJSDate,
    getTimeDifference = _useTimezoneDate.getTimeDifference;

  // Initial state should always have a value, otherwise prev/next buttons cannot work
  var _useState = (0, _react.useState)((0, _helpers.getJSDateWithStartEndOfDay)(value || new Date(), getFromJSDate, isEndOfDay)),
    _useState2 = _slicedToArray(_useState, 2),
    dateObject = _useState2[0],
    setDateObject = _useState2[1];

  // update internal state if external value changes
  (0, _react.useEffect)(function () {
    value && setDateObject((0, _helpers.getJSDateWithStartEndOfDay)(value, getFromJSDate, isEndOfDay));
  }, [value, getFromJSDate, isEndOfDay]);

  // set the correct values for min & max booking dates
  var maxBookingDateFixed = (0, _helpers.getJSDateWithStartEndOfDay)(maxBookingDate, getFromJSDate, isEndOfDay);
  var minBookingDateFixed = (0, _helpers.getJSDateWithStartEndOfDay)(minBookingDate, getFromJSDate, isEndOfDay);

  // dateTimeMeta is derived from the original date object that is already start/end of day
  var dateTimeMeta = (0, _react.useMemo)(function () {
    return getFromJSDate(dateObject);
  }, [dateObject, getFromJSDate]);
  var valueFormatted = dateTimeMeta.toFormat(format);
  var nextDate = dateTimeMeta.plus({
    days: 1
  }).toJSDate();
  var previousDate = dateTimeMeta.minus({
    days: 1
  }).toJSDate();
  return /*#__PURE__*/_react["default"].createElement(DateParts.Popover, {
    automationHook: automationHook,
    align: align,
    triggerW: w !== null && w !== void 0 ? w : width /** TODO:  deprecate width */,
    renderTrigger: function renderTrigger(_ref2) {
      var togglePopover = _ref2.togglePopover,
        closePopover = _ref2.closePopover;
      return /*#__PURE__*/_react["default"].createElement(_DateInputPrevNext["default"], {
        value: valueFormatted,
        hasError: hasError,
        isRequired: isRequired,
        togglePopover: togglePopover,
        disabled: disabled,
        onNext: function onNext() {
          setDateObject(nextDate);
          onChange(nextDate);
          closePopover();
        },
        onPrevious: function onPrevious() {
          setDateObject(previousDate);
          onChange(previousDate);
          closePopover();
        },
        canClickNext: !!dateTimeMeta && !(maxBookingDate && getTimeDifference({
          fromValue: maxBookingDateFixed,
          toValue: nextDate // compare with chosen day
        }) > 0 || isDateBlocked !== null && isDateBlocked !== void 0 && isDateBlocked(nextDate)),
        canClickPrevious: !!dateTimeMeta && !(minBookingDate && getTimeDifference({
          fromValue: minBookingDateFixed,
          toValue: previousDate
        }) < 0 || isDateBlocked !== null && isDateBlocked !== void 0 && isDateBlocked(previousDate)),
        automationHook: (0, _automationHooks.getHook)(automationHook, "trigger")
      });
    }
  }, function (_ref3) {
    var isOpen = _ref3.isOpen,
      closePopover = _ref3.closePopover;
    return /*#__PURE__*/_react["default"].createElement(_DatePickerReactStyled["default"], _extends({
      exactMinBookingDays: true,
      minBookingDays: 1,
      startDate: (0, _helpers.getStartDate)(dateTimeMeta),
      endDate: (0, _helpers.getStartDate)(dateTimeMeta),
      focusedInput: _styled.START_DATE,
      onDatesChange: function onDatesChange(_ref4) {
        var focusedInput = _ref4.focusedInput,
          startDate = _ref4.startDate;
        // no need to set the hours/min/sec/mill because the dateTimeMeta
        // already has them set correctly
        var selectedDate = dateTimeMeta.set({
          day: startDate.getDate(),
          month: startDate.getMonth() + 1,
          year: startDate.getFullYear()
        }).toJSDate();
        setDateObject(selectedDate);
        // call onChange here directly because we are calling closePopover
        // immediately. We don't use the Popover's onClose function because
        // we will not have access to the updated state of dateObject
        onChange(selectedDate);
        if (focusedInput === null) {
          closePopover();
        }
      },
      numberOfMonths: 1,
      minBookingDate: minBookingDateFixed,
      maxBookingDate: maxBookingDateFixed,
      isDateBlocked: isDateBlocked,
      automationHook: automationHook,
      currentDate: dateObject,
      setCurrentDate: setDateObject
    }, rest));
  });
};
DatePickerPrevNext.propTypes = propTypes;
var _default = exports["default"] = DatePickerPrevNext;